import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';

/**
 * Vehicle group DTO for records
 */
@CaslSubject(AppSubjectEnum.VEHICLE_GROUP)
export class VehicleGroupRecordDto extends BaseDto {
  uuid!: string;
  name!: string;
  description?: string | null;
  notes?: string | null;
  files?: FileDto[] | null;
  tags?: TagListDto[] | null;
}
